
import { ROLE_CARRIER, ROLE_OPERATOR } from '../../utils/access';

export const ADMIN_OPTIONS = [
  {
    label: 'Carrier',
    value: ROLE_CARRIER,
  },
  {
    label: 'Postal Operator',
    value: ROLE_OPERATOR,
  },
];

export const CARRIER = {
  Header: 'Carrier',
  accessor: 'name',
};

export const POSTAL_OPERATOR = {
  Header: 'Postal Operator',
  accessor: 'name',
};
